// src/components/shell/PageHeader.js
// En-tête commun à toutes les pages outil de FullMetrix.
//
// Modèle unique (repris de FullMargin) :
//   [icône]  Titre
//   sous-titre en pleine largeur, aligné à gauche (jamais indenté par l'icône)
//   [chips éventuels]                         [actions à droite en desktop]
//
// À utiliser tel quel sur chaque page : c'est ce qui harmonise les titres.
import React from "react";

const cx = (...a) => a.filter(Boolean).join(" ");

export default function PageHeader({
  icon: Icon,
  title,
  subtitle,
  chips = null,
  actions = null,
  className = "",
}) {
  return (
    /* Gouttière pour le cluster flottant (drapeau, thème, avatar) que le shell
       rend en `fixed top-4 right-5` — cf. UserMenu. Sans elle, il passait
       par-dessus les actions de l'en-tête : « Voir le tutoriel » se lisait
       « Voir le tut… ».

       Deux conditions, pour ne pas rétrécir les titres inutilement :
       - seulement si la page fournit des `actions`, les seules concernées ;
       - seulement à partir de `xl`, le seuil où elles remontent sur la ligne
         du titre. En dessous elles passent sous lui, donc hors d'atteinte du
         cluster (qui s'arrête à ~56 px du haut). */
    <header className={cx("min-w-0", actions ? "xl:pr-[184px]" : "", className)}>
      <div className="flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between">
        <div className="min-w-0">
          {/* Icône + titre sur une ligne. */}
          <div className="flex items-center gap-3">
            {Icon ? (
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-violet-600 text-white">
                <Icon size={20} />
              </span>
            ) : null}
            <h1 className="min-w-0 text-[22px] font-extrabold leading-tight tracking-tight text-slate-900 sm:text-[28px] dark:text-white">
              {title}
            </h1>
          </div>

          {/* Sous-titre : pleine largeur, il ne démarre pas sous l'icône. */}
          {subtitle ? (
            <p className="mt-2 max-w-3xl text-sm leading-relaxed text-slate-600 dark:text-white/60">{subtitle}</p>
          ) : null}
        </div>

        {actions ? <div className="flex flex-wrap gap-2 xl:justify-end">{actions}</div> : null}
      </div>

      {chips ? <div className="mt-3 flex flex-wrap items-center gap-2">{chips}</div> : null}
    </header>
  );
}
